import { requestFactory } from './requester';
import { serverUrl } from '../constants/serverUrl';
import { UPLOAD_FIELDS } from '../constants/validation';
import { buildFormData } from '../utils/formData';

export const getAllUserPosts = (jwtToken) => {
	const request = requestFactory(jwtToken);

	return request.get(`${serverUrl}/user-posts`);
};

export const addUserPost = ({ image, caption }, jwtToken) => {
	const request = requestFactory(jwtToken);

	return request.post(`${serverUrl}/user-posts`, buildFormData({ [UPLOAD_FIELDS.POST_IMAGE]: image, caption }));
};

export const updateUserPostCaption = ({ userPostId, caption, jwtToken }) => {
	const request = requestFactory(jwtToken);

	return request.patch(`${serverUrl}/user-posts/${userPostId}`, { caption });
};

export const deleteUserPost = ({ userPostId, jwtToken }) => {
	const request = requestFactory(jwtToken);

	return request.delete(`${serverUrl}/user-posts/${userPostId}`);
};

export const getFollowedUsersPosts = ({ jwtToken, cursor }) => {
	const request = requestFactory(jwtToken);

	const queryString = cursor ? `?cursor=${encodeURIComponent(cursor)}` : '';

	return request.get(`${serverUrl}/user-posts/followed-users-posts${queryString}`);
};

export const getPopularPosts = ({ jwtToken, firstPostId }) => {
	const request = requestFactory(jwtToken);

	const queryString = firstPostId ? `?firstPostId=${encodeURIComponent(firstPostId)}` : '';

	return request.get(`${serverUrl}/user-posts/popular${queryString}`);
};

export const getNextPopularPosts = ({ jwtToken, snapshotTime, shownPostIds }) => {
	const request = requestFactory(jwtToken);

	return request.post(`${serverUrl}/user-posts/popular`, { snapshotTime, shownPostIds });
};

export const likeUserPost = ({ userPostToLikeId, jwtToken }) => {
	const request = requestFactory(jwtToken);

	return request.post(`${serverUrl}/user-posts/like/${userPostToLikeId}`);
};

export const getUserPostLikes = ({ userPostId, jwtToken }) => {
	const request = requestFactory(jwtToken);

	return request.get(`${serverUrl}/user-posts/${userPostId}/likes`);
};

export const unlikeUserPost = ({ userPostToUnlikeId, jwtToken }) => {
	const request = requestFactory(jwtToken);

	return request.post(`${serverUrl}/user-posts/unlike/${userPostToUnlikeId}`);
};
